import React from 'react';
import type { DocumentEditorContainerPropTypes } from './utils/document-editor.types';
import { DocxNativeDocumentEditorContainer } from './docx-native/DocxNativeDocumentEditorContainer';

/**
 * Editor entry point for DEAL DOCUMENTS (sibling of `EditorSwitch`, which does
 * the same for templates).
 *
 * This WAS a two-engine switch during the V4.0 migration. CKEditor has been
 * removed, so there is nothing left to choose between — every deal document
 * opens in the DOCX-native editor. The component is kept (rather than callers
 * being rewired) because it is the stable seam the pages import, and it still
 * owns the prop contract.
 *
 * `editorEngine` is accepted and ignored: `EditorConfiguration.editor_engine`
 * still exists on the backend and is still written as `docx_native`, so callers
 * pass it through. Dropping the prop would churn every call site for nothing.
 */

export type EditorEngine = 'docx_native';

export interface DocumentEditorSwitchProps extends DocumentEditorContainerPropTypes {
  /** Accepted for call-site compatibility; no longer selects anything. */
  editorEngine?: EditorEngine | string | null;
  /** Opens the page-level Compare view from File → "Compare versions…". */
  onCompareVersions?: () => void;
  /** Fired after each successful autosave, so the page can advance the header's
   *  "Last Saved" clock. */
  onSaved?: () => void;
}

export const DocumentEditorSwitch: React.FC<DocumentEditorSwitchProps> = ({
  editorEngine: _editorEngine,
  ...props
}) => <DocxNativeDocumentEditorContainer {...props} />;
